<input
  type="checkbox"
  [checked]="params.data.ignored"
  (change)="onChange($event)"
/>
